import React from 'react';
import { Navigation } from '../components/Navigation.tsx';
import { MissionsBoard } from '../components/MissionsBoard.tsx';
import './MissionsDashboard.css';

export const MissionsDashboard: React.FC = () => {
  return (
    <div className="missions-dashboard">
      <Navigation />
      <header className="missions-dashboard-header">
        <div>
          <h1>Missions</h1>
          <p className="missions-dashboard-subtitle">
            Track missions with status, priority, owners, and dates — inspired by a simple Monday board.
          </p>
        </div>
      </header>
      <main className="missions-dashboard-main">
        <section className="missions-group" aria-labelledby="missions-group-title">
          <h2 id="missions-group-title" className="missions-group-title">
            Active missions
          </h2>
          <MissionsBoard />
        </section>
      </main>
    </div>
  );
};

export default MissionsDashboard;
